// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navigation-icon-btn":"navigation-icon-btn"};